import { useMutation as useReactQueryMutation } from '@tanstack/react-query';

import { useClient } from '../useClient/useClient';

import { UseMutationProps } from './useMutation.types';

// eslint-disable-next-line @typescript-eslint/ban-types
export const useMutation = <TData = unknown, TError = unknown, TVariables extends object = {}, TContext = unknown>({
  mutationFn,
  onSuccess,
  onError,
}: UseMutationProps<TVariables, TData, TError>) => {
  const client = useClient();

  const result = useReactQueryMutation<TData, TError, TVariables, TContext>({
    mutationFn: (variables) => mutationFn(client, variables),
    onSuccess,
    onError,
  });

  return { ...result, isLoading: result.isPending };
};
